const releaseNoteOptions = {
  SIMPLE_LIST: "SIMPLE_LIST",
  LIST_WITH_ICONS: "LIST_WITH_ICONS",
  WALKTHROUGH: "WALKTHROUGH"
};

export default releaseNoteOptions;
